/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, css, Grid, HStack, Skeleton, StackItem, VStack } from '@chakra-ui/react';

import InfiniteScroll from 'react-infinite-scroll-component';

import { Promotion } from './Promotion';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../hooks/use-is-mobile';
import { useTheme } from '../../contexts/ThemeProvider';
import { Label } from '../atoms/Label';
import { formatDataList } from '../../utils';
import { FaFrown } from 'react-icons/fa';
import React, { useEffect } from 'react';
import { usePromotionsInfinity } from '@/service/club/hooks';
import { RequestParameters } from '@/service/types';

export function PromotionGrid({
  params,
  column,
  name,
  fullWidth,
  showMove,
  title,
  onlyBigger = false,
}: {
  params?: RequestParameters;
  column?: boolean;
  name?: string;
  fullWidth?: boolean;
  title?: string;
  showMove?: () => void;
  search?: string;
  onlyBigger?: boolean;
}) {
  const { id, colors } = useTheme();

  const { isFetching, isLoading, fetchNextPage, hasNextPage, data } = usePromotionsInfinity(name, id, {
    ...params,
    page_size: 32,
  });

  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const [formatedPromotions, setFormatedPromotions] = React.useState<any>([]);

  useEffect(() => {
    if (column) {
      const formated = formatDataList(data?.pages.flat() || [], isMobile, onlyBigger);

      setFormatedPromotions(formated);
    }
  }, [isMobile, column, data]);

  if (column) {
    return (
      <Box width={'100%'}>
        <InfiniteScroll
          dataLength={Number(data && data.pages ? data.pages.flat().length : 0)}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          scrollThreshold={0.5}
          loader={
            isLoading ||
            (isFetching && (
              <Grid
                width={'100%'}
                templateColumns={{
                  base: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)',
                }}
                gap={4}
              >
                {new Array(9).fill(0).map((_, i) => (
                  <Skeleton key={i} width={'100%'} borderRadius={'6px'} height="160px" />
                ))}
              </Grid>
            ))
          }
        >
          <VStack width={'100%'} spacing={4}>
            {isLoading && (
              <Grid
                width={'100%'}
                templateColumns={{
                  base: 'repeat(2, 1fr)',
                  md: 'repeat(3, 1fr)',
                }}
                gap={2}
              >
                {new Array(9).fill(0).map((_, i) => (
                  <Skeleton key={i} width={fullWidth ? '100%' : '300px'} borderRadius={'6px'} height="160px" />
                ))}
              </Grid>
            )}
            {!isLoading &&
              formatedPromotions.length > 0 &&
              formatedPromotions?.map((a: any, index: number) => {
                return (
                  <Grid
                    key={index}
                    justifyContent={'center'}
                    alignItems={'center'}
                    display={'flex'}
                    width={'100%'}
                    gap={4}
                  >
                    {a.promos?.map((promo: any) => (
                      <Promotion
                        key={promo.id}
                        isCartaz={promo.category === 'Cinema'}
                        isFullWidth
                        isMobile={isMobile}
                        promotion={promo}
                        onClick={(url) => navigate(url)}
                      />
                    ))}
                  </Grid>
                );
              })}

            {!isLoading && data?.pages.flat()?.length === 0 && (
              <VStack margin={'auto'} spacing={5} paddingTop={'50px'}>
                <FaFrown size="50px" color={colors.primaryColor} />
                <Label textAlign={'center'}>Seu convênio não possui promoções com essa busca até o momento</Label>
              </VStack>
            )}
          </VStack>
        </InfiniteScroll>
      </Box>
    );
  }

  if (!isLoading && !data?.pages.flat()?.length) {
    return null;
  }

  return (
    <>
      <VStack paddingLeft="20px" align={'self-start'} spacing={2} width={`100%`}>
        <HStack
          spacing={2}
          justifyContent={'space-between'}
          width={'100%'}
          paddingRight={{
            base: '20px',
            md: '0px',
          }}
        >
          {title && <Label>{title}</Label>}
          {showMove && (
            <Button
              colorScheme="primary"
              onClick={showMove}
              padding={'0'}
              color={colors.primaryColor}
              fontSize={'16px'}
              fontWeight={'400'}
            >
              Ver mais
            </Button>
          )}
        </HStack>
        <Box
          overflowX="auto"
          whiteSpace="nowrap"
          width={'100%'}
          css={css({
            scrollbarWidth: !isMobile ? 'auto' : 'none',
            '::-webkit-scrollbar': { display: !isMobile ? '' : 'none' },
            WebkitOverflowScrolling: 'touch',
            border: 'none',
          })}
        >
          <HStack spacing={2}>
            {isLoading &&
              new Array(8)
                .fill(0)
                .map((_, i) => (
                  <Skeleton key={i} minWidth={fullWidth ? '340px' : '174px'} borderRadius={'6px'} height="180px" />
                ))}
            {!isLoading &&
              data?.pages.flat()?.map((a, index) => (
                <Box key={a.id} paddingRight={index === data?.pages.flat().length - 1 ? '20px' : '0'}>
                  <Promotion
                    width={fullWidth ? '340px' : '174px'}
                    isMobile={isMobile}
                    promotion={a}
                    onClick={(url) => navigate(url)}
                  />
                </Box>
              ))}
          </HStack>
        </Box>
      </VStack>
    </>
  );
}
